<template>
    <vue-custom-scrollbar id="steps-sidebar">
        <div class="step-container" v-bind:class="{'active-step-container': currentRouteSection === 'projects'}" v-on:click="routeSelector('projects', {})">
            <SVGStepsFolder/>
            <div class="step-text">
                Проекты
            </div>
        </div>
        <div class="step-container" v-bind:class="{'active-step-container': currentRouteSection === 'photo'}" v-on:click="routeSelector('loadPhoto', {project: selectedProject, photo: selectedPhoto})">
            <SVGStepsProjects/>
            <div class="step-text">
                Фото
            </div>
        </div>
        <div class="step-container" v-bind:class="{'active-step-container': currentRouteSection === 'zones'}" v-on:click="routeSelector('planeCategories', {project: selectedProject, photo: selectedPhoto})">
            <SVGStepsZones/>
            <div class="step-text">
                Выделение зон
            </div>
        </div>
        <div class="step-container" v-bind:class="{'active-step-container': currentRouteSection === 'perspective'}" v-on:click="routeSelector('SetScale', {project: selectedProject, photo: selectedPhoto})">
            <SVGStepsPerspective/>
            <div class="step-text">
                Перспектива
            </div>
        </div>
        <div class="step-container" v-bind:class="{'active-step-container': currentRouteSection === 'grouping'}" v-on:click="routeSelector('groupingPlanes', {project: selectedProject, photo: selectedPhoto})">
            <SVGGrouping/>
            <div class="step-text">
                Группировка
            </div>
        </div>
        <div class="step-container" v-bind:class="{'active-step-container': currentRouteSection === 'design'}" v-on:click="routeSelector('designList', {project: selectedProject, photo: selectedPhoto})">
            <SVGStepsTextures/>
            <div class="step-text">
                Дизайн
            </div>
        </div>
        <div class="step-container" v-bind:class="{'active-step-container': currentRouteSection === 'result'}" v-on:click="routeSelector('resultSelectDesign', {project: selectedProject, design: selectedDesign})">
            <SVGStepsResult/>
            <div class="step-text">
                Результат
            </div>
        </div>
    </vue-custom-scrollbar>
</template>

<script>
    import SVGStepsProjects from "../SVG/SVGStepsProjects.vue";
    import SVGStepsPerspective from "../SVG/SVGStepsPerspective.vue";
    import SVGStepsZones from "../SVG/SVGStepsZones.vue";
    import SVGStepsTextures from "../SVG/SVGStepsTextures.vue";
    import SVGStepsResult from "../SVG/SVGStepsResult.vue";
    import SVGStepsFolder from "../SVG/SVGStepsFolder.vue";
    import SVGGrouping from "../SVG/SVGGrouping";
    import vueCustomScrollbar from 'vue-custom-scrollbar';

    export default {
        name: "TheStepsSidebar",
        components: {
            SVGGrouping,
            SVGStepsFolder,
            SVGStepsResult,
            SVGStepsTextures,
            SVGStepsZones,
            SVGStepsPerspective,
            SVGStepsProjects,
            vueCustomScrollbar
        },
        data() {
            return {
                sections: {
                    'projects': 'projects',
                    'selectProject': 'projects',

                    'loadPhoto': 'photo',
                    'viewPhoto': 'photo',
                    'EditPhoto': 'photo',
                    'CropPhoto': 'photo',

                    'SetScale': 'perspective',
                    'SetScaleDistance': 'perspective',
                    'SetPerspectiveSecond': 'perspective',
                    'SetPerspective': 'perspective',
                    'planeCategoriesForPerspective': 'perspective',
                    'planeCategoriesForPerspectiveActivePlane': 'perspective',

                    'planeCategories': 'zones',
                    'wall': 'zones',
                    'window': 'zones',
                    'door': 'zones',
                    'planeCategoriesActiveSelection': 'zones',
                    'additional': 'zones',
                    'additionalManual': 'zones',

                    'groupingPlanes': 'grouping',
                    'groupingPlanesActive': 'grouping',
                    'groupingPlanesActiveEditGroup': 'grouping',

                    'designList': 'design',
                    'designListSelected': 'design',
                    // 'designGroups': 'design',
                    // 'designGroupsSelected': 'design',
                    // 'designGroupsSelectedProduct': 'design',
                    // 'designMaterialsSelected': 'design',
                    'designMaterials': 'design',
                    'designMaterialsSelectedGroup': 'design',

                    'resultSelectDesign': 'result',
                    'resultMaterials': 'result'
                },
                requirements: {
                    projects: [],
                    photo: ['project', 'photo'],
                    perspective: ['project', 'photo'],
                    zones: ['project', 'photo'],
                    grouping: ['project', 'photo'],
                    design: ['project', 'photo'],
                    result: ['project', 'design']
                }
            }
        },
        computed: {
            currentRouteSection() {
                return this.sections[this.$store.state.route.name];
            },
            selectedProject() {
                if (typeof this.$store.state.route.params.projectUUID !== 'undefined') {
                    return this.$store.state.route.params.projectUUID
                } else {
                    return null
                }
            },
            selectedPhoto() {
                if (typeof this.$store.state.route.params.photoID !== 'undefined') {
                    return this.$store.state.route.params.photoID
                } else {
                    return null
                }
            },
            selectedDesign() {
                if (typeof this.$store.state.route.params.designID !== 'undefined') {
                    return this.$store.state.route.params.designID
                } else {
                    return null
                }
            }
        },
        methods: {
            routeSelector(stepName, args) {
                let target = this.sections[stepName]
                for (let key in this.requirements[target]) {
                    if (!args[this.requirements[target][key]]) {
                        return
                    }
                }
                if(stepName === "SetScale"){
                    if(this.$store.getters["active/CHECK_SCAlE_PHOTO"]){
                        this.$router.push({name: 'planeCategoriesForPerspective', query: this.$store.state.route.query }).catch(() => {});
                        return;
                    }
                }
                this.$router.push({name: stepName, query: this.$store.state.route.query}).catch(err => {})
            }
        }
    }
</script>

<style scoped>
    #steps-sidebar {
        height: 100%;
        z-index: 10;
        background-color: white;
        overflow-x: hidden;
        box-sizing: border-box;
        display: block;
        border-right: 2px solid #F2F2F2;
        box-shadow: 7px 1px 5px 0 rgba(0,0,0,0.2);
        flex-grow: 0;
        flex-shrink: 0;
    }

    @media screen and (max-height: 800px) {
        .step-container {
            margin: 10px 0;
        }
        #steps-sidebar {
            width: 80px;
        }
    }

    @media screen and (min-height: 800px) {
        .step-container {
            margin: 20px 0;
        }
        #steps-sidebar {
            width: 100px;
        }
    }

    .step-container {
        width: 100%;
        height: max-content;
        text-align: center;
        cursor: pointer;
        user-select: none;
        color: #BDBDBD
    }

    .step-container:hover {
        color: #A3A3A3;
    }

    .active-step-container {
        color: #626262 !important;
    }
</style>
